// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2242":"e53ba2c476d500be","2888":"0a1f02dce986b109","4219":"7e58e2d7c5b68e10"}[chunkId] + ".css";
};